module.exports = __webpack_public_path__ + "static/manufactured-02121fc1e1435eb0587ed69550bcc1b5.png";